module.exports = __webpack_public_path__ + "static/media/retirement-object-3-0-1.128b77ac.svg";